module.exports = __webpack_public_path__ + "static/excluding5-fc49574efa5b0dd808bf02d4ad0050a6.png";